import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  organization: Yup.number().notOneOf([0], 'Şirket zorunludur.'),
  policy_number: Yup.string().required('Poliçe no zorunludur.'),
  doc_type: Yup.string().required('Poliçe tipi zorunludur.'),
  start_date: Yup.string().required('Başlangıç tarihi zorunludur.'),
  end_date: Yup.string().required('Bitiş tarihi zorunludur.'),
});

export default validationSchema;
